<template>
  <b-container>
    <b-row>
      <b-col class="action_bar_col">
        <router-link :to="{ path: 'BuildDiploma' }"
          ><b-button
            ><v-icon name="graduation-cap" scale="2" /> <br />
            Créer un diplome</b-button
          ></router-link
        >
        <router-link :to="{ path: 'Import' }"
          ><b-button
            ><v-icon name="cloud-upload-alt" scale="2" /> <br />
            Importer une course</b-button
          ></router-link
        >
        <router-link :to="{ path: 'ImportFont' }"
          ><b-button
            ><v-icon name="font" scale="1.5" /> <br />
            Importer une police</b-button
          ></router-link
        >
        <a href="https://sportips.fr/import/ajout_resultat.php" target="_blank"
          ><b-button
            ><v-icon name="file-pdf" scale="1.5" /> <br />
            Ajouter des résultats PDF</b-button
          ></a
        >
        <b-button @click="cleanup"
          ><v-icon name="broom" scale="1.5" /> <br />
          Nettoyer la base</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {};
  },
  methods: {
    cleanup() {
            Axios.get(
        this.$store.getters.base_url+"/import/results/clean.php"
      ).then(function (response) {
        alert("Nettoyage de la base terminée");
      });
    },
  },
};
</script>

<style scoped>
.action_bar_col button {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/component/Admin/ActionBar.vue